import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaAngleUp, FaAngleDown, FaAngleRight, FaAngleLeft } from 'react-icons/fa';
import './Activities.css'
import Cookies from 'universal-cookie';
import { Tooltip as ReactTooltip } from 'react-tooltip';

function PriceItems() {
    const cookies = new Cookies();
    const token = cookies.get('token');
    const [AddPriceItem, setAddPriceItem] = useState(false);
    const [priceItems, setPriceItem] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [collapsed, setCollapsed] = useState(true);
    const [customerCareTypes, setCustomerCareTypes] = useState([]);
    const [newPriceItem, setNewPriceItem] = useState({
        ItemName: '',
        Price: '',
        CustomerCareTypeID: '',
        GeneralCategory: '',
        Frequency: '',
        SN_HoursDay: '',
        SN_HoursNight: '',
        ENA_HoursDay: '',
        ENA_HoursNight: '',
        CW_HoursDay: '',
        CW_HoursNight: '',
        Catering: '',
        Cleaning: '',
        Laundry: '',
        Other: '',
        DateFrom: '',
        DateTo: '',
    });


    useEffect(() => {
        fetchPriceItem();
        fetchCustomerCareTypes();
    }, []);
    const fetchCustomerCareTypes = async () => {
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/customerCareTypes', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
            );
            if (response.ok) {
                const data = await response.json();
                setCustomerCareTypes(data);
            } else {
                console.error('Failed to fetch customer care types');
            }
        } catch (error) {
            console.error('An error occurred while fetching customer care types:', error);
        }
    };

    const fetchPriceItem = async () => {
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/pricelistItems', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            console.log(data)
            setPriceItem(data);
        } catch (error) {
            console.error('Error fetching PriceItem:', error);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
    };

    const filteredItems = priceItems.filter(item =>
        item.ItemName.toLowerCase().includes(searchTerm)
    );

    const handleSort = (key, isNumeric = false) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        const sortedData = [...filteredItems].sort((a, b) => {
            if (isNumeric) {
                return direction === 'ascending'
                    ? (a[key] || 0) - (b[key] || 0)
                    : (b[key] || 0) - (a[key] || 0);
            } else {
                return direction === 'ascending'
                    ? (a[key] || '').toString().localeCompare((b[key] || '').toString())
                    : (b[key] || '').toString().localeCompare((a[key] || '').toString());
            }
        });

        setPriceItem(sortedData);
        setSortConfig({ key, direction });
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? <FaAngleUp /> : <FaAngleDown />;
        }
        return null;
    };


    const handleAddPriceItem = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/pricelistItems', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,

                },
                body: JSON.stringify(newPriceItem),
            });

            if (response.ok) {
                fetchPriceItem();
                setAddPriceItem(false)
                setNewPriceItem({
                    ItemName: '',
                    Price: '',
                    CustomerCareTypeID: '',
                    GeneralCategory: '',
                    Frequency: '',
                    SN_HoursDay: '',
                    SN_HoursNight: '',
                    ENA_HoursDay: '',
                    ENA_HoursNight: '',
                    CW_HoursDay: '',
                    CW_HoursNight: '',
                    Catering: '',
                    Cleaning: '',
                    Laundry: '',
                    Other: '',
                    DateFrom: '',
                    DateTo: '',
                });
            } else {
                console.error('Failed to add PriceItem');
            }
        } catch (error) {
            console.error('Error adding PriceItem:', error);
        }
    };
    const [editItemId, setEditItemId] = useState(null); // Track which activity is being edited
    const [formData, setFormData] = useState({
        ItemName: '',
        Price: '',
        CustomerCareTypeID: '',
        GeneralCategory: '',
        Frequency: '',
        SN_HoursDay: '',
        SN_HoursNight: '',
        ENA_HoursDay: '',
        ENA_HoursNight: '',
        CW_HoursDay: '',
        CW_HoursNight: '',
        Catering: '',
        Cleaning: '',
        Laundry: '',
        Other: '',
        DateFrom: '',
        DateTo: '',
    });
    const handleEditClick = (Item) => {
        setEditItemId(Item.PriceListItemID);
        setFormData({ ...Item }); // Load the clicked activity's data into formData
    };

    const handleSaveClick = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/pricelistItems/${editItemId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                fetchPriceItem();
                setEditItemId(null); // Reset after saving
            } else {
                console.error('Failed to update Item');
            }
        } catch (error) {
            console.error('Error updating Item:', error);
        }
    };

    // const handleEditPriceItem = async (PriceItemID, updatedPriceItem) => {
    //     try {
    //         const response = await fetch(`https://api.cpq.yourcrm.co.za/api/pricelistItems/${PriceItemID}`, {
    //             method: 'PUT',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(updatedPriceItem),
    //         });

    //         if (response.ok) {
    //             fetchPriceItem();
    //         } else {
    //             console.error('Failed to update PriceItem');
    //         }
    //     } catch (error) {
    //         console.error('Error updating PriceItem:', error);
    //     }
    // };

    const handleDeletePriceItem = async (PriceItemID) => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/pricelistItems/${PriceItemID}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.ok) {
                fetchPriceItem();
            } else {
                console.error('Failed to delete PriceItem');
            }
        } catch (error) {
            console.error('Error deleting PriceItem:', error);
        }
    };

    ///
    return (
        <div>
            <div>
                <p>Manage price list here.</p>
                <>

                    <div >
                        <Form.Control
                            type="text"
                            placeholder="Search by Item Name..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="mb-3"
                        />
                        <div className='table-controls'>
                            <Button
                                variant="link"
                                onClick={() => setCollapsed(!collapsed)}
                            >
                                {collapsed ? <FaAngleRight /> : <FaAngleLeft />}
                                {collapsed ? "Expand Columns" : "Collapse Columns"}
                            </Button>
                        </div>
                        <div className='table-wrapper'>
                            <Table striped bordered hover className=''>
                                <thead>
                                    <tr>
                                        <th>Actions</th>
                                        <th onClick={() => handleSort('ItemName')}>Item Name {getSortIndicator('ItemName')}</th>
                                        <th onClick={() => handleSort('Price', true)}>Price {getSortIndicator('Price')}</th>
                                        <th onClick={() => handleSort('CustomerCareTypeID')}>Care Type {getSortIndicator('CustomerCareTypeID')}</th>
                                        {/* <th onClick={() => handleSort('GeneralCategory')}>General Category {getSortIndicator('GeneralCategory')}</th> */}
                                        <th onClick={() => handleSort('Frequency')}>
                                            Frequency {getSortIndicator('Frequency')}
                                        </th>
                                        <th colSpan={2} onClick={() => handleSort('SN_HoursDay', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            SN Hours {getSortIndicator('SN_HoursDay')}
                                        </th>
                                        <th colSpan={2} onClick={() => handleSort('ENA_HoursDay', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            ENA Hours {getSortIndicator('ENA_HoursDay')}
                                        </th>
                                        <th colSpan={2} onClick={() => handleSort('CW_HoursNight', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            CW Hours {getSortIndicator('CW_HoursNight')}
                                        </th>
                                        <th onClick={() => handleSort('Catering', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Catering {getSortIndicator('Catering')}
                                        </th>
                                        <th onClick={() => handleSort('Cleaning', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Cleaning {getSortIndicator('Cleaning')}
                                        </th>
                                        <th onClick={() => handleSort('Laundry', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Laundry {getSortIndicator('Laundry')}
                                        </th>
                                        <th onClick={() => handleSort('Other', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Other {getSortIndicator('Laundry')}
                                        </th>
                                        <th onClick={() => handleSort('DateFrom', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Date From {getSortIndicator('DateFrom')}
                                        </th>
                                        <th onClick={() => handleSort('DateTo', true)} style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                            Date To {getSortIndicator('DateTo')}
                                        </th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr style={{ display: collapsed ? 'none' : '' }}>
                                        <th style={{ top: 39 }}></th>
                                        <th style={{ top: 39 }}></th>
                                        <th style={{ top: 39 }}></th>
                                        <th style={{ top: 39 }}></th>
                                        <th style={{ top: 39 }}></th>
                                        <th style={{ top: 39 }}></th>
                                        <th onClick={() => handleSort('SN_HoursDay', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Day {getSortIndicator('SN_HoursDay')}
                                        </th>
                                        <th onClick={() => handleSort('SN_HoursNight', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Night {getSortIndicator('SN_HoursNight')}
                                        </th>
                                        <th onClick={() => handleSort('ENA_HoursDay', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Day {getSortIndicator('ENA_HoursDay')}
                                        </th>
                                        <th onClick={() => handleSort('ENA_HoursNight', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Night {getSortIndicator('ENA_HoursNight')}
                                        </th>
                                        <th onClick={() => handleSort('CW_HoursDay', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Day {getSortIndicator('CW_HoursDay')}
                                        </th>
                                        <th onClick={() => handleSort('CW_HoursNight', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                            Night {getSortIndicator('CW_HoursNight')}
                                        </th>
                                        <th onClick={() => handleSort('Catering', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                        <th onClick={() => handleSort('Cleaning', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                        <th onClick={() => handleSort('Laundry', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                        <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                        <th onClick={() => handleSort('DateFrom', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                        <th onClick={() => handleSort('DateTo', true)} style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredItems.map(priceItem => (
                                        <tr key={priceItem.PriceListItemID}>
                                            {/* <td className="col-md-10">
                                        <Form.Control
                                            type="text"
                                            value={priceItem.ItemName}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, ItemName: e.target.value })}
                                        />
                                    </td> */}
                                            <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Button variant="primary" onClick={handleSaveClick}>Save</Button>
                                                ) : (
                                                    <>
                                                        <Button variant="link" data-tooltip-id={`edit-tooltip-${priceItem.PriceListItemID}`} onClick={() => handleEditClick(priceItem)}>
                                                            <FaEdit
                                                                style={{ color: '#007bff', fontSize: '1.2rem' }}
                                                                onClick={() => handleEditClick(priceItem)}
                                                            />
                                                        </Button>
                                                        <ReactTooltip style={{ zIndex: 1000 }} id={`edit-tooltip-${priceItem.PriceListItemID}`} place="top" content="Edit Activity" />

                                                        <Button variant="link" onClick={() => {
                                                            if (window.confirm("Are you sure you want to remove this item?")) {
                                                                handleDeletePriceItem(priceItem.PriceListItemID)
                                                            }
                                                        }}>
                                                            <FaTrash style={{ color: '#dc3545', fontSize: '1.2rem' }} />
                                                        </Button>
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.ItemName}
                                                        onChange={(e) => setFormData({ ...formData, ItemName: e.target.value })}
                                                    />
                                                ) : priceItem.ItemName}
                                            </td>
                                            <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Price} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Price: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Price}
                                            </td>
                                            <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.CustomerCareTypeID} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, CustomerCareTypeID: e.target.value })} // Update with setFormData
                                                    />
                                                ) :
                                                    priceItem.CustomerCareTypeID}
                                            </td>
                                            {/* <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.GeneralCategory} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, GeneralCategory: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.GeneralCategory}
                                            </td> */}
                                            <td>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Frequency} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Frequency: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Frequency}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.SN_HoursDay} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, SN_HoursDay: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.SN_HoursDay}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.SN_HoursNight} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, SN_HoursNight: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.SN_HoursNight}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.ENA_HoursDay} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, ENA_HoursDay: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.ENA_HoursDay}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.ENA_HoursNight} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, ENA_HoursNight: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.ENA_HoursNight}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.CW_HoursDay} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, CW_HoursDay: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.CW_HoursDay}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.CW_HoursNight} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, CW_HoursNight: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.CW_HoursNight}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Catering} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Catering: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Catering}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Cleaning} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Cleaning: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Cleaning}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Laundry} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Laundry: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Laundry}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.Other} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, Other: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.Other}
                                            </td>


                                            {/* <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.Price}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, Price: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.CustomerCareTypeID}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, CustomerCareTypeID: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.GeneralCategory}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, GeneralCategory: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.Frequency}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, Frequency: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.SN_HoursDay}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, SN_HoursDay: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.SN_HoursNight}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, SN_HoursNight: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.ENA_HoursDay}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, ENA_HoursDay: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.ENA_HoursNight}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, ENA_HoursNight: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.CW_HoursDay}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, CW_HoursDay: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.CW_HoursNight}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, CW_HoursNight: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.Catering}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, Catering: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.Cleaning}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, Cleaning: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={priceItem.Laundry}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, Laundry: e.target.value })}
                                        />
                                    </td> */}
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="date"
                                                        value={formData.DateFrom ? formData.DateFrom.substring(0, 10) : ''} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, DateFrom: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.DateFrom ? priceItem.DateFrom.substring(0, 10) : ''}
                                            </td>
                                            <td style={{ display: collapsed ? 'none' : 'table-cell' }}>
                                                {editItemId === priceItem.PriceListItemID ? (
                                                    <Form.Control
                                                        type="date"
                                                        value={formData.DateTo ? formData.DateTo.substring(0, 10) : ''} // Use formData
                                                        onChange={(e) => setFormData({ ...formData, DateTo: e.target.value })} // Update with setFormData
                                                    />
                                                ) : priceItem.DateTo ? priceItem.DateTo.substring(0, 10) : ''}
                                            </td>


                                            {/* <td>
                                        <Form.Control
                                            type="date"
                                            value={priceItem.DateFrom}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, DateFrom: e.target.value })}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="date"
                                            value={priceItem.DateTo}
                                            onChange={(e) => handleEditPriceItem(priceItem.PriceListItemID, { ...priceItem, DateTo: e.target.value })}
                                        />
                                    </td> */}
                                            {/* <td>
                                        <Button variant="danger" onClick={() => handleDeletePriceItem(priceItem.PriceListItemID)}>Delete</Button>
                                        
                                    </td> */}

                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <Button onClick={() => setAddPriceItem(true)} className='mt-4'>Add New Price Item</Button>
                </>
            </div>
            <Modal show={AddPriceItem} onHide={() => setAddPriceItem(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Price Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formName">
                            <Form.Label>Price Item Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.ItemName}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, ItemName: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formPrice">
                            <Form.Label>Price</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.Price}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, Price: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCustomerCareTypeID">
                            <Form.Label>Care Recipient Care Type</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.CustomerCareTypeID}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, CustomerCareTypeID: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formGeneralCategory">
                            <Form.Label>General Category</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.GeneralCategory}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, GeneralCategory: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formFrequency">
                            <Form.Label>Frequency</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.Frequency}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, Frequency: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formSN_HoursDay">
                            <Form.Label>SN Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.SN_HoursDay}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, SN_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formSN_HoursNight">
                            <Form.Label>SN Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.SN_HoursNight}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, SN_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formENA_HoursDay">
                            <Form.Label>ENA Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.ENA_HoursDay}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, ENA_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formENA_HoursNight">
                            <Form.Label>ENA Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.ENA_HoursNight}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, ENA_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCW_HoursDay">
                            <Form.Label>CW Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.CW_HoursDay}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, CW_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCW_HoursNight">
                            <Form.Label>CW Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.CW_HoursNight}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, CW_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCatering">
                            <Form.Label>Catering</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.Catering}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, Catering: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCleaning">
                            <Form.Label>Cleaning</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.Cleaning}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, Cleaning: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formLaundry">
                            <Form.Label>Laundry</Form.Label>
                            <Form.Control
                                type="text"
                                value={newPriceItem.Laundry}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, Laundry: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDateFrom">
                            <Form.Label>Date From</Form.Label>
                            <Form.Control
                                type="date"
                                value={newPriceItem.DateFrom}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, DateFrom: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDateTo">
                            <Form.Label>Date To</Form.Label>
                            <Form.Control
                                type="date"
                                value={newPriceItem.DateTo}
                                onChange={(e) => setNewPriceItem({ ...newPriceItem, DateTo: e.target.value })}
                            />
                        </Form.Group>
                        <Button variant="primary" className='mt-4' onClick={handleAddPriceItem}>Add Price Item</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default PriceItems;
